import React from "react"
import {Box} from "@mui/material"

const segmentDelays = ["-0.45s", "-0.3s", "-0.15s", "0s"]

const segmentSx = {
  boxSizing: "border-box",
  display: "block",
  position: "absolute",
  width: "100%",
  height: "100%",
  margin: "5px",
  border: "5px solid #fff",
  borderRadius: "50%",
  borderColor: "#fff transparent transparent transparent",
  animation: "spinnerRotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite",
  "@keyframes spinnerRotate": {
    "0%": {transform: "rotate(0deg)"},
    "100%": {transform: "rotate(360deg)"},
  },
}

function Spinner({centerVertical, color}: {centerVertical?: boolean; color?: string}) {
  return (
    <Box
      sx={{
        display: centerVertical ? "block" : "inline-block",
        position: centerVertical ? "absolute" : "relative",
        width: 64,
        height: 64,
        ...(centerVertical && {top: "50%", left: "50%", mt: "-42px", ml: "-32px"}),
      }}
    >
      {segmentDelays.map((delay, i) => (
        <Box
          key={i}
          sx={{
            ...segmentSx,
            animationDelay: delay,
            ...(color && {borderTopColor: color}),
          }}
        />
      ))}
    </Box>
  )
}

export default Spinner
